import { render, staticRenderFns } from "./SaveChangesModal.vue?vue&type=template&id=3a886bfe&scoped=true"
import script from "./SaveChangesModal.vue?vue&type=script&lang=js"
export * from "./SaveChangesModal.vue?vue&type=script&lang=js"
import style0 from "./SaveChangesModal.vue?vue&type=style&index=0&id=3a886bfe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a886bfe",
  null
  
)

export default component.exports